import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importEOUDetailsApi = createApi({
  reducerPath: "importEOUDetails",
  baseQuery,
  tagTypes: ["importEOUDetails", "EOUDetailsItem"],
  endpoints: (builder) => ({
    createEOUDetails: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/import/product/licEou/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { ImportProductLICEOU: data },
      }),
      invalidatesTags: ["importEOUDetails"],
    }),
    updateEOUDetails: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/import/product/licEou/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { shipment: data },
      }),
      invalidatesTags: ["importEOUDetails"],
    }),
    getEOUDetailsId: builder.query({
      query: ({ id }) => `/import/product/licEou/${id}`,
      transformResponse: (response) => response?.data,
      providesTags: ["importLICScheme"],
    }),
    createEOUDetailsItem: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `import/product/licEouItem/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { ImportProductLICEOUItem: data },
      }),
      invalidatesTags: ["EOUDetailsItem"],
    }),

    // getEOCItemId: builder.query({
    //   query: ({id}) => `import/product/licEouItem/${id}`,
    //   transformResponse: (response) => {
    //     const data = response?.data ?? [];
    //     const normalized = Array.isArray(data) ? data : [data];
    //     return normalized.map((item,idx) => ({
    //       ...item,
    //       SrNo : idx+1,
    //     }));
    //   },
    //   providesTags: ["EOUDetailsItem"],
    // }),
    getEOCItemId: builder.query({
      query: ({ id }) => {
        return `/import/product/licEouItem/${id}`;
      },
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized?.map((item, idx) => ({
          ...item,
          SrNo: idx + 1,
          id:item.importLICId
        }));
      },
      providesTags: ["EOUDetailsItem"],
    }),
    updateEOUDetailsItem: builder.mutation({
      query: ({ id,subId, ...data }) => ({
        url: `/import/product/licEouItem/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: {ImportProductLICEOUItem:data},
      }),
      invalidatesTags: ["EOUDetailsItem"],
    }),

    deleteEOUDetailsItem: builder.mutation({
      query: ({id }) => ({
        url: `/import/product/licEouItem/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },

      }),
      invalidatesTags: ["EOUDetailsItem"],
    }),






    
    



  })


});
export const {
  useCreateEOUDetailsMutation,
  useUpdateEOUDetailsMutation,
  useLazyGetEOUDetailsIdQuery,
  useCreateEOUDetailsItemMutation,
  useLazyGetEOCItemIdQuery,
  useUpdateEOUDetailsItemMutation,
  useDeleteEOUDetailsItemMutation

  
} = importEOUDetailsApi;
